import SecondaryMarketItem from './secondary-market-item';

export default SecondaryMarketItem;
